import { useMutation, useQueryClient } from '@tanstack/react-query';

import { ScheduleService } from '@/openapi';
import { dateToString } from '@/util/date';
import { queryKeys } from '@/util/queryKeys';

export interface CreateScheduleMutationParams {
  beginDate: Date;
  endDate: Date;
}

export const useCreateScheduleMutation = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: async (params: CreateScheduleMutationParams) => {
      const { beginDate, endDate } = params;
      return ScheduleService.scheduleServiceCreateSchedule({
        query: {
          fromDate: dateToString(beginDate),
          toDate: dateToString(endDate),
        },
      });
    },
    onSettled: async (_data, _error, variables) => {
      // Invalidate schedule queries for the affected date range
      await queryClient.invalidateQueries({
        queryKey: queryKeys.schedule.byDate(dateToString(variables.beginDate)),
      });
      await queryClient.invalidateQueries({ queryKey: queryKeys.schedule.all });
    },
  });
};
